module.exports = __webpack_public_path__ + "static/media/snes-controller-w3.5009a6eb.png";